import { httpClient } from '@/infra/protocols/http';
import { IPodcastDTO } from '@/modules/podcasts/dtos/podcast.dto';
import { IPodcast } from '@/modules/podcasts/entities/podcast.entity';
import { PodcastMapper } from '@/modules/podcasts/mappers/podcast.mapper';

export async function updatePodcast(
  params: UpdatePodcastService.Params,
  data: UpdatePodcastService.Payload,
): Promise<UpdatePodcastService.Response> {
  const body = {
    nome: data.name,
    descricao: data.description,
    imagem: data.fileName,
  };

  const response = await httpClient.put<IPodcastDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}`,
    body,
  );
  return PodcastMapper.toPresentation(response);
}

export namespace UpdatePodcastService {
  export interface Params {
    projectId: string;
    podcastId: string;
  }

  export interface Payload {
    name: string;
    description: string;
    fileName?: string;
  }

  export type Response = IPodcast;
}
